// Live nowcast for this screen, served by our backend. The backend talks to
// the WeatherWalay station API with its own credentials and picks the nearest
// active station (or the fallback) — the display only ever sees the result,
// authenticated with the same device key used for overlay polling.

import { API_BASE, SCREEN_ID, SCREEN_KEY } from '../../../config';

export async function fetchScreenWeather() {
  const res = await fetch(`${API_BASE}/api/screens/${encodeURIComponent(SCREEN_ID)}/weather`, {
    headers: { 'X-Screen-Key': SCREEN_KEY }
  });

  if (!res.ok) {
    throw new Error(`Weather request failed (${res.status})`);
  }

  // { weather: {...normalized reading}, station: { id, name, distanceKm, isFallback }, fetchedAt }
  return res.json();
}

// Live nowcast for every restaurant location at once (not just this screen's
// own), used by the intro globe to label each branch's pin with its real
// temperature/condition. Authenticated with this screen's own device key —
// any paired screen may read it, since none of it is screen-specific.
export async function fetchAllLocationsWeather() {
  const res = await fetch(`${API_BASE}/api/screens/${encodeURIComponent(SCREEN_ID)}/weather/locations`, {
    headers: { 'X-Screen-Key': SCREEN_KEY }
  });

  if (!res.ok) {
    throw new Error(`Weather request failed (${res.status})`);
  }

  // { locations: { <slug>: normalizedReading|null }, fetchedAt }
  return res.json();
}
